import React from 'react';

import aggregateSpectrograms from '@client/utils/aggregateSpectrograms';
import i18n from '@client/utils/i18n';
import { SpectrogramPoint, SpectrumMixDoc, SpectrumMixLightChannel } from '@ledium/types';
import { ItemList } from '@ledium/ui-common';

type SpectrumMixItem = SpectrumMixDoc & {
    id: string;
    lightChannels: (SpectrumMixLightChannel & { spectrogram: SpectrogramPoint[] })[];
};

const SpectrumMixerMainMenu = () => {
    function isLocked(spectrum: SpectrumMixItem) {
        if (spectrum.locked?.reason) {
            if (spectrum.locked.reason === 'RUNNING_PROJECT') {
                return i18n('spectrum_mix_running_project', spectrum.locked.projectName) as string;
            }
        }
        return false as const;
    }

    function isLinked(spectrum: SpectrumMixItem) {
        if (spectrum.linked?.reason === 'LINKED_PROJECT') {
            return i18n('spectrum_mix_linked_project', spectrum.linked.projectName) as string;
        }
        return false as const;
    }

    function chart(item: SpectrumMixItem): SpectrogramPoint[] {
        return aggregateSpectrograms(item.lightChannels);
    }

    return <ItemList<SpectrumMixItem> chart={chart} isLocked={isLocked} isLinked={isLinked} />;
};

export default SpectrumMixerMainMenu;
